import { useEffect, useState } from 'react';
import { PokeMapNav } from './PokeMapNav';
import { TrainerCard } from './TrainerCard';
import { QuickMenu } from './QuickMenu';
import { studentAPI } from '../utils/api';
import { loadUploadedGifs } from '../utils/helpers';

/**
 * Top header used on every student page. Wraps the explore-map navigation
 * with a floating TrainerCard pinned to the top-left and a QuickMenu below
 * (replaces the old scattered button bar).
 */
export const StudentMapHeader = () => {
  const [student, setStudent] = useState(null);
  const [gifReady, setGifReady] = useState(false);

  const reload = async () => {
    try {
      const r = await studentAPI.getMe();
      const list = Array.isArray(r.data) ? r.data : (r.data?.students || []);
      if (list.length > 0) setStudent(list[0]);
    } catch (e) { /* page-level loaders surface errors */ }
  };

  useEffect(() => {
    reload();
    loadUploadedGifs().then(() => setGifReady(true));
    const onRefresh = () => reload();
    window.addEventListener('student-refresh', onRefresh);
    return () => window.removeEventListener('student-refresh', onRefresh);
  }, []);

  // The TrainerCard owns the backpack dialog. We trigger it via a custom
  // window event so the QuickMenu (sibling component) can ask it to open.
  const openBag = () => {
    window.dispatchEvent(new CustomEvent('open-trainer-backpack'));
  };

  return (
    <div className="relative" data-testid="student-map-header">
      <PokeMapNav />
      <TrainerCard student={student} onReload={reload} gifCacheReady={gifReady} />
      <QuickMenu onOpenBag={openBag} />
    </div>
  );
};

export default StudentMapHeader;
